export enum PopoverMenuItemType {
    SEPARATOR       = 'separator',
    HEADER          = 'header',
    ITEM            = 'item',    // regular item
    POPOVER         = 'popover',    // a eto chto ?
    SUBMENU         = 'submenu', // ??? chto takoe custom custom ???
    COMPONENT       = 'component',   // very custom component
    CUSTOM_POPOVER  = 'custom-popover'  // ???

}

export function OptionHeader(title:string):Option {
    return {
        type    : PopoverMenuItemType.HEADER,
        title   : title
    }

}

export function OptionSeparator():Option {
    return {
        type    : PopoverMenuItemType.SEPARATOR
    }
}

export type PopoverMenuProps = {
    hidePopover                 : callback,
    menuParams                  : any,
    onPopoverKeyDownListener    : callback

}
